<template>
  <div
    id="project-gallery"
    v-if="parent && gallery"
    class="row"
    :class="{'photography-padding':parent.$route.name==='photography'}"
  >
    <light-box :selectedLightBox="selectedLightBox" :parent="parent"/>

    <div
      id="project-description"
      :class="{'col-sm-12 col-md-12':parent.layout=='sm'|| parent.layout=='md'}"
      :style="{'background-color':currentProjectView.bgColor}"
      v-if="currentProjectView!==null"
    >
      <div class="content" v-html="currentProjectView.description"></div>
    </div>
    <div v-if="currentProjectView!==null && parent.$route.name==='projects'" class="row">
      <div
        class="image-container animated project-view"
        v-for="(image, index) in gallery.images.split(',')"
        :key="index"
        :style="{'width':getWidth(image)}"
      >
        <img v-lazy="getImageUrl(image)" :key="getImageUrl(image)">
      </div>
    </div>

    <div v-if="currentProjectView!==null && parent.$route.name==='photography'" class="row">
      <a
        class="image-container animated col-lg-4 col-md-6 col-sm-12 photography-view"
        v-for="(image, index) in gallery.images.split(',')"
        :key="index"
        @click="openLightBox(image)"
      >
        <img v-lazy="getImageUrl(image)" :key="getImageUrl(image)">
      </a>
    </div>
  </div>
</template>


<script>
import LightBox from "./Lightbox.vue";

export default {
  name: "project-view",
  props: ["currentProjectView", "gallery", "parent"],
  components: { LightBox },
  mounted() {
    window.onscroll = (e) => {
      const allImages = document.querySelectorAll(".image-container");
      const doneImages = document.querySelectorAll(".image-container.fadeInUp");
      const footer = document.querySelector(".project-footer");
      if (footer !== null) {
        if (allImages.length !== doneImages.length) {
          allImages.forEach((ele) => {
            if (this.isOnScreen(ele) && ele.querySelector("img").getAttribute("lazy") === "loaded" && !ele.classList.contains("fadeInUp")) {
              ele.classList.add("fadeInUp");
            }

            if (ele.querySelector("img").getAttribute("lazy") === "error" && !ele.classList.contains("remove")) {
              ele.classList.add("remove");
            }
          });
        }
        //reach bottom
        if (footer.offsetTop + 300 <= window.scrollY + window.innerHeight && doneImages.length > 1) {
          this.$eventBus.$emit("showFooter");
        }

        //remove error
      }
    };
  },
  methods: {
    getImageUrl(img) {
      const image = img.split("|")[0];
      const imageWithExd = image.split(/\.(?=[^\.]+$)/);
      const imageName = imageWithExd[0].trim();
      const extension = imageWithExd[1].trim();

      return `http://williamsoo.com.au${this.gallery.path}/${imageName}-${this.parent.layout}.${extension}`;
    },
    getWidth(img) {
      if ((this.parent.layout !== "lg" && this.parent.layout !== "xl") || typeof img.split("|")[1] === "undefined") {
        return "auto";
      }
      const width = img.split("|")[1].trim();
      if (width === "full") {
        return "100%";
      }
      if (width === "half") {
        return "50%";
      }
    },
    isOnScreen(ele) {
      const docViewTop = window.scrollY;
      const docViewBottom = docViewTop + window.innerHeight;

      const elemTop = ele.offsetTop;
      const elemBottom = elemTop + ele.clientHeight;

      return elemBottom >= docViewTop && elemTop <= docViewBottom;
    },
    openLightBox(img) {
      this.selectedLightBox = this.getImageUrl(img);
    },
  },
  data() {
    return {
      selectedLightBox: null,
    };
  },
  beforeDestroy() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style >
.row {
  width: 100%;
}
a {
  cursor: pointer;
}
.layout-sm #project-gallery,
.layout-md #project-gallery {
  padding: 0 !important;
}
.layout-sm #project-description,
.layout-md #project-description {
  padding: 1rem;
  margin-bottom: 2rem;
  text-align: center;
}
.layout-sm .image-container.project-view,
.layout-md .image-container.project-view {
  margin-bottom: 2rem;
}
.image-container.remove {
  display: none;
}
.image-container.project-view {
  transition: all 0.6s ease-in-out;
  float: left;
  margin: auto;
  text-align: center;
  box-sizing: border-box;
  opacity: 0;
  margin-bottom: 4rem;
}

.photography-padding {
  padding: 0 0.1rem;
}
.photography-view {
  height: auto;
  box-sizing: border-box;
  padding: 0rem 0.2rem;
}
.image-container img {
  width: 100%;
}
#project-description {
  background-color: var(--color);
  margin-left: auto;
  box-sizing: border-box;
  padding: 0 80px 80px 80px;
  color: white;
  margin-bottom: 75px;
  width: 50%;
}
#project-description h2 {
  margin-top: 0;
  margin-bottom: 2rem;
  font-size: 1rem;
  font-weight: bold;
}
#project-gallery {
  width: 100%;
  transition: all 1s ease-in-out;
  overflow: hidden;
  max-height: 0;
}
#project-gallery.active {
  overflow-y: auto;
  max-height: 9999999px;
}
.website-link {
  font-weight: bold;
  opacity: 0.6;
  margin-top: 2rem;
}
.layout-sm .website-link,
.layout-md .website-link {
  margin-bottom: 2rem;
}

.website-link a {
  text-transform: uppercase;
  text-decoration: none;
  cursor: pointer;
  color: white;
  vertical-align: middle;
}
.website-link span {
  text-transform: uppercase;
  padding: 0px 7px;
}
</style>
